<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <!-- begin: ประเภทกิจกรรม -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ประเภทกิจกรรม:</label>
                  <span class="form-control-plaintext">{{
                    mktObjectives
                  }}</span>
                </div>
              </div>
              <!-- end: ประเภทกิจกรรม -->

              <!-- begin: ชื่อกิจกรรม -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อกิจกรรม:</label>
                  <span class="form-control-plaintext">{{
                    mktActivityName
                  }}</span>
                </div>
              </div>
              <!-- end: ชื่อกิจกรรม -->

              <!-- begin: ตัวเทนจำหน่าย -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ตัวเทนจำหน่าย:</label>
                  <span class="form-control-plaintext">{{ mktAgentName }}</span>
                </div>
              </div>
              <!-- end: ตัวเทนจำหน่าย -->

              <!-- begin: ชื่อร้านค้า -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อร้านค้า:</label>
                  <span class="form-control-plaintext">{{ mktShopName }}</span>
                </div>
              </div>
              <!-- end: ชื่อร้านค้า -->

              <!-- begin: ชื่อร้านค้า 2 -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ชื่อร้านค้า 2:</label>
                  <span class="form-control-plaintext">{{ mktShopName2 }}</span>
                </div>
              </div>
              <!-- end: ชื่อร้านค้า 2 -->

              <!-- begin: จังหวัด -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">จังหวัด:</label>
                  <span class="form-control-plaintext">{{
                    mktProvinceName
                  }}</span>
                </div>
              </div>
              <!-- end: จังหวัด -->

              <!-- begin: ประเภทร้านค้า -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ประเภทร้านค้า:</label>
                  <span class="form-control-plaintext">{{ mktShopType }}</span>
                </div>
              </div>
              <!-- end: ประเภทร้านค้า -->

              <!-- begin: วันที่ -->
              <div
                v-if="
                  mktObjectivesCode == 'MKT_ACTIVITY_TYPE_SURVEY_OFF_PREMISE' ||
                    mktObjectivesCode == 'MKT_ACTIVITY_TYPE_SURVEY_ON_PREMISE'
                "
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label class="label">วันที่ตรวจเยี่ยมร้านค้า:</label>
                  <span class="form-control-plaintext">{{
                    mktActivityDate
                  }}</span>
                </div>
              </div>
              <div
                v-if="
                  mktObjectivesCode == 'MKT_ACTIVITY_TYPE_NEWSHOP_ON_PREMISE' ||
                    mktObjectivesCode == 'MKT_ACTIVITY_TYPE_NEWSHOP_OFF_PREMISE'
                "
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label class="label">วันที่เปิดร้านค้าใหม่:</label>
                  <span class="form-control-plaintext">{{
                    mktActivityDate
                  }}</span>
                </div>
              </div>
              <!-- end: วันที่ -->

              <!-- begin: วันที่เริ่มต้น -->
              <div
                v-if="mktObjectivesCode == 'MKT_ACTIVITY_TYPE_FOOD_FESTIVAL'"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label class="label"
                    >วันที่เริ่มต้น กิจกรรมมหกรรมอาหาร:</label
                  >
                  <span class="form-control-plaintext">{{
                    mktActivityDateStart
                  }}</span>
                </div>
              </div>

              <div
                v-if="mktObjectivesCode == 'MKT_ACTIVITY_TYPE_EVENT'"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label class="label">วันที่เริ่มต้น กิจกรรม Event:</label>
                  <span class="form-control-plaintext">{{
                    mktActivityDateStart
                  }}</span>
                </div>
              </div>
              <!-- end: วันที่เริ่มต้น -->

              <!-- begin: วันที่สิ้นสุด -->
              <div
                v-if="mktObjectivesCode == 'MKT_ACTIVITY_TYPE_FOOD_FESTIVAL'"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด กิจกรรมมหกรรมอาหาร:</label>
                  <span class="form-control-plaintext">{{
                    mktActivityDateEnd
                  }}</span>
                </div>
              </div>
              <div
                v-if="mktObjectivesCode == 'MKT_ACTIVITY_TYPE_EVENT'"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"
              >
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด กิจกรรม Event:</label>
                  <span class="form-control-plaintext">{{
                    mktActivityDateEnd
                  }}</span>
                </div>
              </div>
              <!-- end: วันที่สิ้นสุด -->

              <!-- begin: PG เชียร์ขาย -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">PG เชียร์ขาย: </label>
                  <ul id="example-1">
                    <li v-for="item in mktSaleItemPG" :key="item.brandId">
                      {{ item.brandName }} จำนวน {{ item.qty }}
                    </li>
                    <span v-if="mktSaleItemPG.length == 0">
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <!-- end: PG เชียร์ขาย -->

              <!-- begin: ยอดขาย(ถัง) -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ยอดขาย(ถัง): </label>
                  <ul id="example-1">
                    <li v-for="item in mktSaleItem" :key="item.brandId">
                      {{ item.brandName }} จำนวน {{ item.qty }}
                    </li>
                    <span v-if="mktSaleItem.length == 0">
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <!-- end: ยอดขาย(ถัง) -->

              <!-- begin: การสนับสนุน -->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label class="label">การสนับสนุน: </label>
                  <ul id="example-1">
                    <li v-if="mktBuget != 0">
                      งบประมาณ จำนวน {{ mktBuget }} บาท
                    </li>
                  </ul>
                  <ul id="example-1">
                    <li v-for="item in mktItem" :key="item.brandId">
                      {{
                        item.itemTypeCodeName != null
                          ? item.itemTypeCodeName
                          : item.productBrandName != null
                          ? item.productBrandName
                          : item.productGroupName != null
                          ? item.productGroupName
                          : item.productTypeName != null
                          ? item.productTypeName
                          : null
                      }}
                      {{ item.productName != null ? item.productName : "" }}
                      จำนวน {{ item.qty }}
                      <ul>
                        <li v-for="itemB in item.brandItems" :key="itemB.index">
                          {{ itemB.productBrand }}
                        </li>
                      </ul>
                    </li>
                    <span v-if="mktItem.length == 0">
                      -
                    </span>
                  </ul>
                </div>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label class="label">หมายเหตุ: </label>
                  <ul id="example-1">
                    <span>
                      {{ mktRemark }}
                    </span>
                    <span v-if="!mktRemark">
                      -
                    </span>
                  </ul>
                </div>
              </div>
              <!-- end: การสนับสนุน -->
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  components: {},
  data: function() {
    var self = this;

    return {
      mktObjectives: null,
      mktActivityName: null,
      mktAgentName: null,
      mktShopName: null,
      mktShopName2: null,
      mktProvinceName: null,
      mktActivityDate: null,
      mktActivityDateStart: null,
      mktActivityDateEnd: null,
      mktShopType: null,
      mktSaleItemPG: [],
      mktSaleItem: [],
      mktBuget: null,
      mktItem: [],
      mktObjectivesCode: null,
      mktRemark: null,
    };
  },

  methods: {},
  computed: {},
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Marketing/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null) {
            self.mktRemark = response.data.remark;

            self.mktObjectives = response.data.objectives;
            self.mktActivityName =
              response.data.activityName != null
                ? response.data.activityName
                : "-";
            (self.mktAgentName = response.data.agentName),
              (self.mktShopName =
                response.data.shopName != null ? response.data.shopName : "-");
            self.mktShopName2 =
              response.data.shopName2 != null && response.data.shopName2 != ""
                ? response.data.shopName2
                : "-";
            self.mktProvinceName = response.data.provinceName;
            self.mktActivityDate =
              response.data.activityDateString != null
                ? response.data.activityDateString
                : "-";
            self.mktActivityDateStart =
              response.data.activityDateStartString != null
                ? response.data.activityDateStartString
                : "-";
            self.mktActivityDateEnd =
              response.data.activityDateEndString != null
                ? response.data.activityDateEndString
                : "-";
            self.mktShopType =
              response.data.shopType != null ? response.data.shopType : "-";
            (self.mktBuget = new Intl.NumberFormat().format(
              response.data.budget
            )),
              (self.mktItem = response.data.items);
            self.mktObjectivesCode = response.data.objectivesCode;
            if (response.data.saleItems != null) {
              (self.mktSaleItemPG = response.data.saleItems.filter(
                (o) => o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_PG"
              )),
                (self.mktSaleItem = response.data.saleItems.filter(
                  (o) => o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_SALE"
                ));
            }
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed

        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Marketing/MarketingDetail.vue